import React from 'react';
import { ContentWrapper } from '../../styles/sideContainerStyles';
import { EditFields } from './EditFields';
import { Resume } from './Resume';

export function Content(): JSX.Element {
  return (
    <ContentWrapper>
      <Resume />
      <EditFields />
    </ContentWrapper>
  );
}
